import { render, staticRenderFns } from "./addNewNumbers2.vue?vue&type=template&id=2493b132&scoped=true"
import script from "./addNewNumbers2.vue?vue&type=script&lang=js"
export * from "./addNewNumbers2.vue?vue&type=script&lang=js"
import style0 from "./addNewNumbers2.vue?vue&type=style&index=0&id=2493b132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493b132",
  null
  
)

export default component.exports